import {
    AppConfig,
    ServerConfig,
    setConfig,
    setRawRemoteConfig,
    StaticConfig as LibStaticConfig,
} from '@superbet-group/web.lib.config';

import { logger } from '@app/logger';
import { enterMaintenance } from '@app/utils/redirect';
import { transformServerConfig } from '@core/mappers/country/transformServerConfig';
import { staticConfig } from './static';
import { StaticConfig } from '@src/config/staticTypes';
import Betler from './playerAccountManagement/Betler';
import { isBetlerPoland } from '@src/app/utils/isBetlerPoland';
import { merge as _merge } from 'lodash';
import { betlerPolandCmsOverride } from '@src/config/betlerPoland/betlerPolandCmsOverride';

type DisjointType<Type, DisjointFrom> = {
    [K in keyof Type]: K extends keyof DisjointFrom ? never : Type[K];
};
type UnionOfDistinct<A, B extends DisjointType<B, A>> = A & B;

function initializeConfig() {
    try {
        let dynamicConfig = transformServerConfig(window.superbetServerConfig, staticConfig as LibStaticConfig);

        if (isBetlerPoland()) {
            dynamicConfig = _merge(dynamicConfig, betlerPolandCmsOverride);
        }

        const config: UnionOfDistinct<ServerConfig, StaticConfig> = {
            ...staticConfig,
            ...dynamicConfig,
        };

        // TODO we will move this to new config once ready
        config.environment.isProdEnvironment = window.superbetServerConfig.isProductionConfig || false;
        config.services.paymentProvidersUrl = config.environment.isProdEnvironment
            ? 'https://superbet-content.freetls.fastly.net/cached-superbet'
            : 'https://superbet-content-stage.freetls.fastly.net/cached-superbet';

        if (isBetlerPoland()) {
            config.services.playerAccountManagement = Betler;
        }

        setConfig(config as AppConfig);
        setRawRemoteConfig(Object.freeze({ ...window.superbetServerConfig }));

        // Intentionally a require! Some singletons are created upon running the file.
        // We need to set the config before importing them.
        require('@core/services/configs/initializeInstances').initializeSingletonInstances(config);
    } catch (error) {
        console.error(error);
        logger.error(new Error('Unable to load application configuration!'));
        enterMaintenance();
    }
}

initializeConfig();
